var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector / back (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11631 0.116211L10.8841 1.88398L4.76796 8.00009L10.8841 14.1162L9.11631 15.884L1.23242 8.00009L9.11631 0.116211Z",
    fill: "#13161F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon_back.b86117595fb6df3270538b257ebb63ed.svg";
export { ForwardRef as ReactComponent };